
import { defineComponent, computed, watch } from "vue";
import InnerCategoryComponent from "@/components/categories/InnerCategoryComponent.vue";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import FormModal from "@/components/modals/FormModal.vue";
export default defineComponent({
  name: "ListPage",
  components: {
    InnerCategoryComponent,
    FormModal,
    KTToolbar,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const key = route.meta.key;
    store.dispatch(Actions.SETUP_LIST, { key: route.meta.key });

    const getDynamicList = computed(() => {
      return store.getters.getDynamicList({ key: route.meta.key });
    });

    /****** COMPUTED ******/
    const getCategories = computed(() => {
      return store.getters.getCategories;
    });
    const getKey = computed(() => {
      return useRoute().meta.key;
    });
    store.dispatch(Actions.SET_IS_FROM_LIST, {
      key: route.meta.key,
      flag: true,
    });
    watch(route, (newRoute) => {
      if (newRoute.path.includes("list")) {
        store.dispatch(Actions.SETUP_LIST, {
          key: newRoute.meta.key,
        });
      }
    });

    /****** ACTIONS ******/

    return {
      name,
      route,
      getCategories,
      getKey,
      getDynamicList,
    };
  },
});
